import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import { useAuth } from "../../Context/AuthContext";
import {
  Button,
  TextField,
  Box,
  Typography,
  Select,
  TextareaAutosize,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  FormHelperText,
  Checkbox,
  ListItemText,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { useForm, Controller, Form } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Divider from "@mui/material/Divider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { PickersOutlinedInput } from "@mui/x-date-pickers/PickersTextField";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment-timezone";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const style = {
  position: "absolute",
  top: "54%",
  left: "50%",
  right: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  height: 600,
  overflow: "auto",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "2px",

  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "#d9d9d9 #fff", // For Firefox
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d9d9d9",
  },
};

const Interactionmodal = ({
  open,
  onClose,
  selectedData = {},
  interactionType,
  onStatusUpdate,
}) => {
  const { register, handleSubmit, reset } = useForm();
  const { token } = useAuth();
  console.log("selected dataaa", selectedData);

  // onst [rmOptions, setRmOptions] = useState([]);
  const parseWealthProducts = (data) => {
    if (!data) return [];
    const ids = data.split(",").map((id) => parseInt(id.trim())); // Parse each id as integer
    return ids.map((id) => {
      const product = wealthproductTypes.find((item) => item.id === id);
      return product ? product.masterValueDesc : id;
    });
  };
  const parsedOtherBusiness = (data) => {
    if (!data) return [];
    const ids = data.split(",").map((id) => parseInt(id.trim())); // Parse each id as integer
    return ids.map((id) => {
      const product = otherBusinessTypes.find((item) => item.id === id);
      return product ? product.masterValueDesc : id;
    });
  };
  console.log(selectedData, "selectedData2");
  const convertDescToIds = (descriptions) => {
    return descriptions.map((desc) => {
      const product = wealthproductTypes.find(
        (item) => item.masterValueDesc === desc
      );
      return product ? product.id : desc;
    });
  };
  const [managerIdNameMap, setManagerIdNameMap] = useState({});
  const [isReferralRowData, setIsReferralRowData] = useState();
  const [charCount, setCharCount] = useState(0);
  const [discussionBrief, setDiscussionBrief] = useState(
    selectedData?.discussion_brief || ""
  );
  const [discussionBriefError, setDiscussionBriefError] = useState("");
  const [engagementTypeError, setEngagementTypeError] = useState("");
  const [locationdesc, setlocationdesc] = useState(
    selectedData?.location || ""
  );
  const [reqdesc, setreqdesc] = useState(
    selectedData?.client_requirement || ""
  );
  const [duration, setDuration] = useState("");
  const [reqotheradvisor, setreqotheradvisor] = useState("");
  const [reqothercount, setreqothercount] = useState("");
  const [locationcharCount, setLocationCharCount] = useState(0);
  const [reqcharCount, setreqcharCount] = useState(0);
  const [portfoliodesc, setPortfoliodesc] = useState(
    selectedData?.estimated_portfolio_value || ""
  );
  const [portfolioCount, setportfolioCount] = useState(0);
  const [followupdesc, setFollowupdesc] = useState(
    selectedData?.followup_location || ""
  );
  const [followupcharcount, setfollowupcharcount] = useState(0);
  const [additionalcomment, setadditionalcomment] = useState(
    selectedData?.comment || ""
  );
  const [additionalcommentcharcount, setadditionalcommentcharcount] =
    useState(0);
  const [engagementTypes, setEngagementTypes] = useState([]);
  const [selectedEngagementType, setSelectedEngagementType] = useState(
    selectedData?.engagement_type || ""
  );
  const [locationTypes, setlocationTypes] = useState([]);
  const [selectedLocationTypes, setSelectedLocationTypes] = useState(
    selectedData?.location_type || ""
  );
  const [meetingDate, setMeetingDate] = useState(null);
  const [expectedDateClosure, setExpectedDateClosure] = useState(null);
  const [meetingDuration, setMeetingDuration] = useState(" ");
  const [wealthproductTypes, setwealthproductTypes] = useState([]);
  const initialSelectedWealthProduct = selectedData?.wealth_product_discussed
    ? selectedData.wealth_product_discussed.split(",")
    : [];
  const [selectedwealthproduct, setselectedwealthproduct] = useState(
    parseWealthProducts(selectedData?.wealth_product_discussed)
  );
  console.log(selectedData, "selectedData");

  // const [selectedwealthproduct, setselectedwealthproduct] = useState(parseWealthProducts(selectedData?.wealth_product_discussed));
  const [otherBusinessTypes, setotherBusinessTypes] = useState([]);
  const initialSelectedOtherBusinessType =
    selectedData?.other_business_opportunity
      ? selectedData.other_business_opportunity.split(",")
      : [];
  const [selectedotherbusinesstype, setSelectedotherbusinesstype] = useState(
    parsedOtherBusiness(selectedData?.other_business_opportunity)
  );
  const [statustypes, setStatustypes] = useState([]);
  const [selectedStatustype, setselectedStatustype] = useState(
    selectedData?.status || ""
  );
  const [leadstatustypes, setleadstatustypes] = useState([]);
  const [selectedleadstatustype, setselectedleadstatustype] = useState(
    selectedData?.lead_status || ""
  );
  const [annualincometypes, setannualincometypes] = useState([]);
  const [selectedPortfolioRange, setSelectedPortfolioRange] = useState("");
  const [selectedannualincometypes, setselectedannualincometypes] = useState(
    selectedData?.estimated_annual_income || ""
  );
  const [followuptypes, setfollowuptypes] = useState([]);
  const [selectedfollowuptype, setSelectedfollowuptype] = useState(
    selectedData?.followup_type || ""
  );
  const [followuplocationtypes, setfollowuplocationtype] = useState([]);
  const [selectedfollowuplocationtype, setselectedfollowuplocationtype] =
    useState(selectedData?.followup_location_type || "");
  const [actualPortfolioValue, setActualPortfolioValue] = useState(
    selectedData?.actual_portfolio_value || ""
  );
  const [meetingDateTime, setMeetingDateTime] = useState(null);
  const [meetingdurationtypes, setmeetingdurationtypes] = useState([]);
  const [selectedmeetingduration, setselectedmeetingduration] = useState("");

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      styles: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const formatDate = (date) => {
    const parsedDate = dayjs(date);
    return parsedDate.isValid()
      ? parsedDate.format("YYYY-MM-DD HH:mm:ss")
      : null;
  };
  const wealthProductMap = {};
  wealthproductTypes.forEach((item) => {
    wealthProductMap[item.masterValueDesc] = item.id;
  });
  const otherBusinessMap = {};
  otherBusinessTypes.forEach((item) => {
    otherBusinessMap[item.masterValueDesc] = item.id;
  });
  console.log("openvalue111", selectedwealthproduct);

  const cancelHandler = () => {
    onClose(false);
    // reset();
  };

  // const handleengagementChange = (event) => {
  //   const value = event.target.value;
  //   setSelectedEngagementType(value);
  //   // setEngagementTypeError(value ? '' : 'Please select engagement type');

  // };

  // const getEngagementtypeData = async () => {
  //   try {
  //     const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/engagement_type`;
  //     const response = await axios(url);
  //     // console.log("engagementdata", response);
  //     setEngagementTypes(response.data.response)
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  useEffect(() => {
    const convertToIST = (date) => {
      const localDate = new Date(date); // Create a Date object
      const utcDate = new Date(
        localDate.getTime() + localDate.getTimezoneOffset() * 60000
      ); // Convert to UTC
      const istDate = new Date(utcDate.getTime() + (5 * 60 + 30) * 60000); // Add IST offset (+5:30)

      return istDate;
    };

    setDiscussionBrief(selectedData?.discussion_brief || "");
    setSelectedEngagementType(selectedData?.engagement_type || "");

    // Convert to Indian Standard Time (IST)
    const formattedMeetingDate = selectedData?.meeting_at
      ? dayjs(selectedData.meeting_at)
      : null;
    setMeetingDate(formattedMeetingDate);

    // console.log("meetingDate in IST:", formattedMeetingDate);

    setselectedmeetingduration(selectedData?.meeting_duration || "");
    setSelectedLocationTypes(selectedData?.location_type || "");
    setlocationdesc(selectedData?.location || "");
    setreqdesc(selectedData?.client_requirement || "");
    setreqotheradvisor(selectedData?.other_advisor || "");
    setselectedwealthproduct(
      parseWealthProducts(selectedData?.wealth_product_discussed)
    );
    setSelectedotherbusinesstype(
      parsedOtherBusiness(selectedData?.other_business_opportunity)
    );

    console.log("selected wealth products others:", selectedotherbusinesstype);
    setselectedStatustype(selectedData?.status || "");
    setselectedleadstatustype(selectedData?.lead_status || "");
    setActualPortfolioValue(selectedData?.actual_portfolio_value || "");

    // Format selectedData.expected_date_of_closure to IST timezone

    const formattedExpectedDateClosure = selectedData?.expected_date_of_closure
      ? dayjs(selectedData.expected_date_of_closure)
      : null;

    setExpectedDateClosure(formattedExpectedDateClosure);
    setselectedannualincometypes(selectedData?.estimated_annual_income || "");
    setSelectedPortfolioRange(selectedData?.estimated_portfolio_range || "");
    setPortfoliodesc(selectedData?.estimated_portfolio_value || "");
    setSelectedfollowuptype(selectedData?.followup_type || "");

    // Convert follow-up date and time to IST
    const formattedMeetingDateTime = selectedData?.followup_date_n_time
      ? dayjs(selectedData.followup_date_n_time)
      : null;
    setMeetingDateTime(formattedMeetingDateTime || null);

    setselectedfollowuplocationtype(selectedData?.followup_location_type || "");
    setFollowupdesc(selectedData?.followup_location);
    setadditionalcomment(selectedData?.comment || "");
  }, [selectedData, wealthproductTypes, otherBusinessTypes]);

  console.log("meeting date", meetingDate);

  const formatDuration = (duration) => {
    if (!duration) return "00:00";

    // Ensure duration is a string
    duration = String(duration);

    const parts = duration.split(":");
    let hours = parts[0] || "00";
    let minutes = parts[1] || "00";

    // Handle case where duration is a single number, like "12"
    if (parts.length === 1) {
      hours = parts[0];
      minutes = "00";
    }

    // Ensure two digits for hours and minutes
    hours = hours.length === 1 ? "0" + hours : hours;
    minutes = minutes.length === 1 ? "0" + minutes : minutes;

    return `${hours}:${minutes}`;
  };

  const handleDurationChange = (event) => {
    const { value } = event.target;
    const isValid =
      /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value) ||
      value === "" ||
      /^[0-9:]*$/.test(value);

    if (isValid) {
      setMeetingDuration(value);
    }
  };

  console.log("openvalue112", selectedwealthproduct);

  const transformSelectedValues = (selectedArray) => {
    return selectedArray.map((desc) => wealthProductMap[desc]).join(",");
  };
  const transformSelectedValuesother = (selectedArray) => {
    return selectedArray.map((desc) => otherBusinessMap[desc]).join(",");
  };

  const OnSubmitdata = async () => {
    const selectedWealthProductString = transformSelectedValues(
      selectedwealthproduct
    );
    const selectedotherbusinessstring = transformSelectedValuesother(
      selectedotherbusinesstype
    );
    const formattedMeetingDate = meetingDate ? formatDate(meetingDate) : null;
    const formattedMeetingDateTime = meetingDateTime
      ? formatDate(meetingDateTime)
      : null;
    const formattedExpectedDateClosure = expectedDateClosure
      ? formatDate(expectedDateClosure)
      : null;

    const headers = {
      "x-access-token": token,
    };

    try {
      if (selectedStatustype === 23) {
        // Update referral status
        try {
          await axios.put(
            `${apiUrl}/CCE/api/v1/referalEngine/updateStatus`,
            {
              clientId: selectedData?.clientId,
              status: "lead",
            },
            { headers }
          );
        } catch (error) {
          console.error("Error updating referral status", error);
          return; // Exit if the status update API call fails
        }
      } else if (selectedStatustype === 24) {
        // Update lead status
        try {
          await axios.put(
            `${apiUrl}/CCE/api/v1/referalEngine/updateStatus`,
            {
              clientId: selectedData?.clientId,
              status: "client",
            },
            { headers }
          );
        } catch (error) {
          console.error("Error updating lead status", error);
          return; // Exit if the status update API call fails
        }
      } else if (selectedStatustype === 25) {
        // Determine status based on interactionType
        let newStatus = "";
        if (interactionType === "lead") {
          newStatus = "leadDrop";
        } else {
          newStatus = "clientDrop";
        }

        // Update to dropped or other status
        try {
          await axios.put(
            `${apiUrl}/CCE/api/v1/referalEngine/updateStatus`,
            {
              clientId: selectedData?.clientId,
              status: newStatus, // Set appropriate status
            },
            { headers }
          );
        } catch (error) {
          console.error("Error updating status", error);
          return; // Exit if the status update API call fails
        }
      }

      // Final submission
      const response = await axios.put(
        `${apiUrl}/CCE/api/v1/referalEngine/updateReferralInteraction`,
        {
          id: selectedData?.id,
          discussion_brief: discussionBrief,
          engagement_type: selectedEngagementType,
          meeting_at: formattedMeetingDate,
          meeting_duration: selectedmeetingduration,
          location_type: selectedLocationTypes,
          location: locationdesc,
          client_requirement: reqdesc,
          other_advisor: reqotheradvisor,
          status: selectedStatustype,
          lead_status: selectedleadstatustype,
          expected_date_of_closure: formattedExpectedDateClosure,
          estimated_annual_income: selectedannualincometypes,
          estimated_portfolio_value: portfoliodesc,
          followup_type: selectedfollowuptype,
          followup_date_n_time: formattedMeetingDateTime,
          followup_location_type: selectedfollowuplocationtype,
          followup_location: followupdesc,
          comment: additionalcomment,
          wealth_product_discussed: selectedWealthProductString,
          other_business_opportunity: selectedotherbusinessstring,
        },
        { headers }
      );

      console.log("response edit", response.data);
      if (response?.data?.statusMessage === "Success") {
        toast.success("Interaction Detail updated successfully");
        onStatusUpdate("success");
        // window.location.reload();
      } else {
        toast.error("Update failed");
        onStatusUpdate("failure");
      }

      console.log("resva", response);
      setDiscussionBrief("");
      setSelectedEngagementType("");
      setMeetingDate(null);
      setMeetingDuration("");
      setSelectedLocationTypes("");
      setlocationdesc("");
      setreqdesc("");
      setselectedwealthproduct([]);
      setSelectedotherbusinesstype([]);
      setselectedStatustype("");
      setselectedleadstatustype("");
      setExpectedDateClosure(null);
      setselectedannualincometypes("");
      setPortfoliodesc("");
      setMeetingDateTime(null);
      setSelectedfollowuptype("");
      setselectedfollowuplocationtype("");
      setadditionalcomment("");
      console.log("sere;e", selectedWealthProductString);
    } catch (error) {
      console.error("Error submitting data", error);
      toast.error("An error occurred while submitting data");
    }

    onClose(false);
    onStatusUpdate("success");
  };

  const handleReasonChange = (event) => {
    const value = event.target.value;
    setDiscussionBrief(value);
    setDiscussionBriefError(value ? "" : "Please enter discussion brief");
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setselectedwealthproduct(
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleLocationdescChange = (event) => {
    const input = event.target.value;
    setlocationdesc(input);
    setLocationCharCount(input.length);
  };
  const handleRequirementChange = (event) => {
    const input = event.target.value;
    setreqdesc(input);
    setreqcharCount(input.length);
  };
  const handleRequirementChangeother = (event) => {
    const input = event.target.value;
    setreqotheradvisor(input);
    setreqothercount(input.length);
  };
  const handlePortfolioChange = (event) => {
    const input = event.target.value;
    setPortfoliodesc(input);
    setportfolioCount(input.length);
  };
  const handlePortfolioRangeChange = (event) => {
    setSelectedPortfolioRange(event.target.value);
  };
  const handleActualPortfolioChange = (event) => {
    const input = event.target.value;
    let numericValue = input.replace(/,/g, "");
    if (numericValue === "") {
      setActualPortfolioValue("");
      return;
    }
    if (!/^\d*$/.test(numericValue)) {
      return;
    }
    if (parseInt(numericValue, 10) > 1000000000) {
      return;
    }
    const formattedValue = parseInt(numericValue, 10).toLocaleString("en-IN");
    setActualPortfolioValue(formattedValue);
  };
  const handlefollowChange = (event) => {
    const input = event.target.value;
    setFollowupdesc(input);
    setfollowupcharcount(input.length);
  };
  const handleadditionalcommentChange = (event) => {
    const input = event.target.value;
    setadditionalcomment(input);
    setadditionalcommentcharcount(input.length);
  };

  const getEngagementtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/engagement_type`;
      const response = await axios.get(url, {});
      console.log("engagementdata", response);
      setEngagementTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLocationtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/location_type`;
      const response = await axios.get(url, {});

      let locationTypesData = response.data.response;

      if (interactionType === "lead") {
        locationTypesData = locationTypesData.map((item) =>
          item.masterValueDesc === "Client Office"
            ? { ...item, masterValueDesc: "Prospect Office" }
            : item
        );
      }

      setlocationTypes(locationTypesData);
    } catch (e) {
      console.log(e);
    }
  };

  const getWealthproducttypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/Wealth_product_discussed`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setwealthproductTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  console.log("waelthndata", wealthproductTypes);
  const getOtherBusinesstypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/other_business_opportunity`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setotherBusinessTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
    console.log("waelthndata", wealthproductTypes);
  };
  const getstatustypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setStatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLeadstatusData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/lead_status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setleadstatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getfollowupData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/follow_up_type`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setfollowuptypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getfollowlocationData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/followup_location_type`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setfollowuplocationtype(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getmeetingdurationData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/meeting_duration`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setmeetingdurationtypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  // console.log("wealth product",se)

  useEffect(() => {
    getEngagementtypeData();
    getLocationtypeData();
    getWealthproducttypeData();
    getOtherBusinesstypeData();
    getstatustypeData();
    getLeadstatusData();
    getAnnualincomeData();
    getfollowupData();
    getfollowlocationData();
    getmeetingdurationData();
  }, []);

  console.log(isReferralRowData);

  const handleengagementChange = (event) => {
    const value = event.target.value;
    setSelectedEngagementType(value);
    setEngagementTypeError(value ? "" : "Please select engagement type");
  };
  const handleLocationChange = (event) => {
    setSelectedLocationTypes(event.target.value);
  };
  const handlemeetingdurationChange = (event) => {
    setselectedmeetingduration(event.target.value);
  };

  const handleStatusChange = (event) => {
    setselectedStatustype(event.target.value);
  };

  const handleLeadStatusChange = (event) => {
    setselectedleadstatustype(event.target.value);
  };
  const handlefollowupChange = (event) => {
    setSelectedfollowuptype(event.target.value);
  };
  const handlefollowuplocationChange = (event) => {
    setselectedfollowuplocationtype(event.target.value);
  };

  const handleAnnualIncomeChange = (event) => {
    setselectedannualincometypes(event.target.value);
  };

  const handleDateChange = (newValue) => {
    setMeetingDate(newValue);
    console.log("new value date", newValue);
  };

  const handleDateTimeChange = (newValue) => {
    setMeetingDateTime(newValue);
    console.log("datetimevalue", meetingDateTime);
  };

  const handleexpectedDateChange = (newValue) => {
    setExpectedDateClosure(newValue);
    console.log("new dateee value", newValue);
  };
  const handleChangeWealth = (event) => {
    setselectedwealthproduct(event.target.value);
  };
  const handleChangeOther = (event) => {
    setSelectedotherbusinesstype(event.target.value);
  };
  const renderSelectedValues = (selected) => selected.join(", ");
  if (!open) return null;
  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            onClick={cancelHandler}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              cursor: "pointer",
              color: "#666666",
              zIndex: 1,
            }}
          >
            <CloseIcon sx={{ fontSize: 30 }} />
          </Box>
          <form onSubmit={handleSubmit(OnSubmitdata)}>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                sx={{
                  fontSize: "22px",
                  marginBottom: "15px",
                  marginTop: "-20px",
                }}
              >
                <b>Interaction Form</b>
              </Typography>
            </Box>
            <Paper sx={styles.papercss}>Discussion Details</Paper>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Box>
                <Box sx={{ fontSize: "14px", margin: "8px 0px -10px 0px" }}>
                  Discussion Brief
                </Box>
                <TextField
                  multiline
                  // label="Type here.."
                  variant="outlined"
                  value={discussionBrief}
                  rows={3}
                  onChange={handleReasonChange}
                  inputProps={{ maxLength: 150 }}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  error={!!discussionBriefError}
                  helperText={
                    discussionBriefError ||
                    `${discussionBrief?.length}/150 characters. Enter upto 150 characters. Please add what was discussed in the meeting in brief. Hobbies /likes /dislikes/assets /profile.`
                  }
                  sx={{
                    mt: 2,
                    width: "700px",
                    // backgroundColor: "#f5f5f5",
                    "& .MuiInputBase-root": {
                      backgroundColor: "#f5f5f5",
                    },
                    "& .MuiFormHelperText-root": {
                      textAlign: "left",
                      marginLeft: "-1px",
                    },
                  }}
                />
                {/* <FormHelperText sx={{fontSize:"12px"}}>Enter upto 1024 characters. Please add what was discussed in the meeting in brief. Hobbies /likes /dislikes/assets /profile</FormHelperText> */}
              </Box>
              <Box>
                <Box sx={{ fontSize: "14px", margin: "12px 0px -10px 0px" }}>
                  Engagement Type
                </Box>

                <FormControl
                  sx={{ width: "300px", pr: 1, mt: 2 }}
                  size="medium"
                  error={!!engagementTypeError}
                >
                  {/* <InputLabel>Select Engagement Type</InputLabel> */}
                  <Select
                    value={selectedEngagementType}
                    onChange={handleengagementChange}
                    inputProps={{ readOnly: true }}
                    sx={{
                      backgroundColor: "#f5f5f5",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d3d3d3",
                      },
                    }}
                    //  input={<OutlinedInput label='Select Engagement Type' />}
                  >
                    {engagementTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.masterValueDesc}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText
                    sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                  >
                    Please select what was the mode of the call.
                  </FormHelperText>
                </FormControl>
              </Box>
            </Stack>
            <Paper sx={styles.papercss}>Meeting Time</Paper>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Box sx={{ width: "300px" }}>
                <Box sx={{ fontSize: "14px", margin: "8px 0px 4px 0px" }}>
                  Meeting Date & Time
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    value={meetingDate}
                    onChange={handleDateChange}
                    inputProps={{ readOnly: true }}
                    sx={{
                      backgroundColor: "#f5f5f5",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d3d3d3",
                      },
                    }}
                    // Set the format to 12-hour format with AM/PM
                    format="DD/MM/YYYY hh:mm A"
                  />
                  <FormHelperText sx={{ fontSize: "12px" }}>
                    Please select the date of the meeting and the start time of
                    the meeting.
                  </FormHelperText>
                </LocalizationProvider>
              </Box>

              {selectedEngagementType !== 1 && selectedEngagementType !== 5 && (
                <Box>
                  <Box sx={{ fontSize: "14px", margin: "12px 0px -10px 0px" }}>
                    Meeting Duration
                  </Box>

                  <FormControl
                    sx={{ width: "300px", pr: 1, mt: 2 }}
                    size="medium"
                    error={!!engagementTypeError}
                  >
                    {/* <InputLabel>Select Engagement Type</InputLabel> */}
                    <Select
                      value={selectedmeetingduration}
                      onChange={handlemeetingdurationChange}
                      inputProps={{ readOnly: true }}
                      sx={{
                        backgroundColor: "#f5f5f5",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#d3d3d3",
                        },
                      }}
                      //  input={<OutlinedInput label='Select Engagement Type' />}
                    >
                      {meetingdurationtypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.masterValueDesc}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                    >
                      Please select meeting duration
                    </FormHelperText>
                  </FormControl>
                </Box>
              )}
            </Stack>
            <Box></Box>
            {/* <Divider sx={{border:"1px solid gray",width:"105%",textAlign:"center",margin:"8px"}}/> */}
            {/* {selectedEngagementType === 4 && ( */}
              <Box>
                <Paper sx={styles.papercss}>Meeting Location</Paper>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                >
                  <Box>
                    <Box
                      sx={{ fontSize: "15px", margin: "12px 0px -18px 0px" }}
                    >
                      Location Type
                    </Box>

                    <FormControl
                      sx={{ width: "300px", pr: 1, mt: 3 }}
                      size="medium"
                    >
                      {/* <InputLabel>Select Location</InputLabel> */}
                      <Select
                        value={selectedLocationTypes}
                        onChange={handleLocationChange}
                        inputProps={{ readOnly: true }}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d3d3d3",
                          },
                        }}
                        // input={<OutlinedInput label='Select Year' />}
                      >
                        {locationTypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{ fontSize: "12px", marginLeft: "1px" }}
                      >
                        Please select where the meeting was held.
                      </FormHelperText>
                    </FormControl>
                  </Box>
                  <Box>
                    <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
                      Location
                    </Box>
                    <TextField
                      multiline
                      // label="Type here.."
                      variant="outlined"
                      value={locationdesc}
                      rows={3}
                      onChange={handleLocationdescChange}
                      helperText={`${locationdesc?.length}/150 characters. Enter upto 150 characters. Please add the exact address of the meeting, if done face-to-face.`}
                      inputProps={{ maxLength: 150 }}
                      InputProps={{ readOnly: true }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "700px",
                        "& .MuiInputBase-root": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                    {/* <FormHelperText sx={{fontSize:"12px",marginLeft:"-0.5px"}}>Enter upto 255 characters. Please add the exact address of the meeting, if done face-to-face. </FormHelperText> */}
                  </Box>
                </Stack>
              </Box>
            {/* )} */}
            <Paper sx={styles.papercss}>Requirement</Paper>
            {interactionType === "lead" ? (
              <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
                Lead Requirement
              </Box>
            ) : (
              <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
                Client Requirement
              </Box>
            )}
            <TextField
              multiline
              // label="Type here.."
              variant="outlined"
              value={reqdesc}
              rows={3}
              onChange={handleRequirementChange}
              helperText={`${reqdesc?.length}/150 characters. Enter upto 150 characters. Briefly explain the client expectation.`}
              inputProps={{ maxLength: 150 }}
              InputProps={{ readOnly: true }}
              fullWidth
              // sx={{ mt: 2,width:"1115px" }}
              sx={{
                mt: 2,
                width: "1115px",
                "& .MuiInputBase-root": {
                  backgroundColor: "#f5f5f5",
                },
                "& .MuiFormHelperText-root": {
                  textAlign: "left",
                  marginLeft: "-1px",
                },
              }}
            />
            {/* <FormHelperText sx={{fontSize:"12px"}}>Enter upto 1024 characters. Briefly explain the client expectation. */}
            {/* </FormHelperText> */}
            <Box>
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
              >
                <Box>
                  <Box>
                    <Box sx={{ fontSize: "14px", margin: "12px 0px 5px 0px" }}>
                      Wealth Product Discussed
                    </Box>

                    <FormControl sx={{ width: "300px" }}>
                      <Select
                        labelId="techniques-label"
                        id="demo-multiple-checkbox-techniques"
                        multiple
                        value={selectedwealthproduct}
                        onChange={handleChangeWealth}
                        input={<OutlinedInput />}
                        renderValue={renderSelectedValues}
                        MenuProps={MenuProps}
                        inputProps={{ readOnly: true }}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d3d3d3",
                          },
                        }}
                      >
                        {wealthproductTypes.map((name) => (
                          <MenuItem key={name.id} value={name.masterValueDesc}>
                            <Checkbox
                              checked={
                                selectedwealthproduct?.indexOf(
                                  name.masterValueDesc
                                ) > -1
                              }
                            />
                            <ListItemText primary={name.masterValueDesc} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormHelperText sx={{ fontSize: "12px" }}>
                      Select all that was discussed or can be proposed.
                    </FormHelperText>
                  </Box>
                </Box>
                <Box>
                  <Box>
                    <Box sx={{ fontSize: "14px", margin: "12px 0px 5px 0px" }}>
                      Other Business Opportunity
                    </Box>

                    <FormControl sx={{ width: "300px" }}>
                      <Select
                        labelId="techniques-label"
                        id="demo-multiple-checkbox-techniques"
                        multiple
                        value={selectedotherbusinesstype}
                        onChange={handleChangeOther}
                        input={<OutlinedInput />}
                        renderValue={renderSelectedValues}
                        MenuProps={MenuProps}
                        inputProps={{ readOnly: true }}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d3d3d3",
                          },
                        }}
                      >
                        {otherBusinessTypes.map((name) => (
                          <MenuItem key={name.id} value={name.masterValueDesc}>
                            <Checkbox
                              checked={
                                selectedotherbusinesstype?.indexOf(
                                  name.masterValueDesc
                                ) > -1
                              }
                            />
                            <ListItemText primary={name.masterValueDesc} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormHelperText sx={{ fontSize: "12px" }}>
                      Select all that was discussed or can be proposed.
                    </FormHelperText>
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ fontSize: "14px", margin: "12px 0px 5px 0px" }}>
                    Estimated Annual Income
                  </Box>
                  <FormControl sx={{ width: "300px" }} size="medium">
                    <Select
                      value={selectedannualincometypes}
                      onChange={handleAnnualIncomeChange}
                      inputProps={{ readOnly: true }}
                      sx={{
                        backgroundColor: "#f5f5f5",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#d3d3d3",
                        },
                      }}
                    >
                      {annualincometypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.masterValueDesc}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormHelperText sx={{ fontSize: "12px" }}>
                    Select what according to you would be the client's estimated
                    Income.
                  </FormHelperText>
                </Box>
              </Stack>
            </Box>
            <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
              Other Advisor
            </Box>
            <TextField
              multiline
              // label="Type here.."
              variant="outlined"
              value={reqotheradvisor}
              rows={3}
              onChange={handleRequirementChangeother}
              helperText={`${reqothercount?.length}/150 characters. Enter upto 150 characters. Briefly explain other advisor details..`}
              inputProps={{ maxLength: 150 }}
              InputProps={{ readOnly: true }}
              fullWidth
              // sx={{ mt: 2,width:"1115px" }}
              sx={{
                mt: 2,
                width: "1115px",
                "& .MuiInputBase-root": {
                  backgroundColor: "#f5f5f5",
                },
                "& .MuiFormHelperText-root": {
                  textAlign: "left",
                  marginLeft: "-1px",
                },
              }}
            />
            <Box sx={{ marginTop: "12px" }}></Box>

            <Paper sx={styles.papercss}>Status</Paper>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Box>
                <Box>
                  <Box sx={{ fontSize: "14px", margin: "12px 0px -10px 0px" }}>
                    Status
                  </Box>

                  <FormControl
                    sx={{ width: "300px", pr: 1, mt: 2 }}
                    size="medium"
                  >
                    {/* <InputLabel>Select Status</InputLabel> */}
                    <Select
                      value={selectedStatustype}
                      onChange={handleStatusChange}
                      inputProps={{ readOnly: true }}
                      sx={{
                        backgroundColor: "#f5f5f5",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#d3d3d3",
                        },
                      }}
                      // input={<OutlinedInput label='Select Year' />}
                    >
                      {statustypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          {type.masterValueDesc}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      sx={{ fontSize: "12px", marginLeft: "1px" }}
                    >
                      Please select according to you what is the client status
                      after the meeting.
                    </FormHelperText>
                  </FormControl>
                </Box>
              </Box>
              {selectedStatustype !== 24 && selectedStatustype !== 25 && (
                <Box>
                  <Box>
                    <Box
                      sx={{ fontSize: "14px", margin: "12px 0px -10px 0px" }}
                    >
                      Lead Status
                    </Box>

                    <FormControl
                      sx={{ width: "300px", pr: 1, mt: 2 }}
                      size="medium"
                    >
                      {/* <InputLabel>Select Lead Status</InputLabel> */}
                      <Select
                        value={selectedleadstatustype}
                        onChange={handleLeadStatusChange}
                        inputProps={{ readOnly: true }}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d3d3d3",
                          },
                        }}
                        // input={<OutlinedInput label='Select Year' />}
                      >
                        {leadstatustypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                      >
                        Select based on your understanding the probability of
                        onboarding the client.
                      </FormHelperText>
                    </FormControl>
                  </Box>
                </Box>
              )}
            </Stack>
            {selectedStatustype !== 25 ? (
              <Box>
                <Paper sx={styles.papercss}>Estimation</Paper>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                >
                  {selectedStatustype === 24 ? (
                    <Stack
                      direction="row"
                      divider={<Divider orientation="vertical" flexItem />}
                      spacing={2}
                    >
                      <Box>
                        <Box
                          sx={{ fontSize: "14px", margin: "12px 0px 0px 0px" }}
                        >
                          Closed Date
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              value={expectedDateClosure}
                              onChange={handleexpectedDateChange}
                              disableFuture // Ensure current or past dates
                              inputProps={{ readOnly: true }}
                              sx={{
                                backgroundColor: "#f5f5f5",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#d3d3d3",
                                },
                              }}
                            />
                          </DemoContainer>
                          <FormHelperText sx={{ fontSize: "12px" }}>
                            Select the date when the client was onboarded.
                          </FormHelperText>
                        </LocalizationProvider>
                      </Box>
                      <Box sx={{ width: "300px" }}>
                        <Box
                          sx={{
                            fontSize: "14px",
                            margin: "12px 0px 5px 0px",
                            textAlign: "left",
                          }}
                        >
                          Actual Portfolio Value
                        </Box>
                        <TextField
                          size="medium"
                          // type="number"
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                          value={actualPortfolioValue}
                          onChange={handleActualPortfolioChange}
                          // InputProps={{
                          //   inputProps: { min: 0 },
                          // }}
                        />
                        <FormHelperText
                          sx={{
                            fontSize: "12px",
                            textAlign: "left",
                            marginLeft: "0px",
                            maxWidth: "100%",
                            display: "block",
                          }}
                        >
                          Enter the client's actual portfolio value.
                        </FormHelperText>
                      </Box>
                    </Stack>
                  ) : (
                    <Stack
                      direction="row"
                      divider={<Divider orientation="vertical" flexItem />}
                      spacing={2}
                    >
                      <Box sx={{ width: "300px" }}>
                        <Box
                          sx={{ fontSize: "14px", margin: "12px 0px 0px 0px" }}
                        >
                          Expected Date of Closure
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              value={expectedDateClosure}
                              onChange={handleexpectedDateChange}
                              format="DD/MM/YYYY" // Customize the format here
                              disablePast // Ensure future dates
                              inputProps={{ readOnly: true }}
                              sx={{
                                backgroundColor: "#f5f5f5",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#d3d3d3",
                                },
                              }}
                            />
                          </DemoContainer>
                          <FormHelperText sx={{ fontSize: "12px" }}>
                            Select what according to you would be the client
                            onboarding date.
                          </FormHelperText>
                        </LocalizationProvider>
                      </Box>
                      <Box sx={{ width: "300px" }}>
                        <Box
                          sx={{
                            fontSize: "14px",
                            margin: "12px 0px 5px 0px",
                            textAlign: "left",
                          }}
                        >
                          Estimated Portfolio Value
                        </Box>
                        <FormControl sx={{ width: "100%" }} size="medium">
                          <Select
                            inputProps={{ readOnly: true }}
                            sx={{
                              backgroundColor: "#f5f5f5",
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#d3d3d3",
                              },
                            }}
                            value={selectedPortfolioRange}
                            onChange={handlePortfolioRangeChange}
                          >
                            {annualincometypes.map((type) => (
                              <MenuItem key={type.id} value={type.id}>
                                {type.masterValueDesc}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText
                            sx={{
                              fontSize: "12px",
                              textAlign: "left",
                              marginLeft: "0px",
                              maxWidth: "100%",
                              display: "block",
                            }}
                          >
                            Select what according to you would be the client's
                            estimated Portfolio Value.
                          </FormHelperText>
                        </FormControl>
                      </Box>
                    </Stack>
                  )}
                </Stack>
                {selectedStatustype === 24 ? (
                  <Box>
                    <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
                      Portfolio value
                    </Box>
                    <TextField
                      multiline
                      variant="outlined"
                      value={portfoliodesc}
                      rows={3}
                      onChange={handlePortfolioChange}
                      helperText={`${portfolioCount}/150 characters. Enter up to 150 characters. Please share Asset wise portfolio details.`}
                      inputProps={{ maxLength: 150 }}
                      InputProps={{ readOnly: true }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "1115px",
                        "& .MuiInputBase-root": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                  </Box>
                ) : (
                  <Box>
                    <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
                      Estimated Portfolio value
                    </Box>
                    <TextField
                      multiline
                      variant="outlined"
                      value={portfoliodesc}
                      rows={3}
                      onChange={handlePortfolioChange}
                      helperText={`${portfolioCount}/150 characters. Enter up to 150 characters. Please share Asset wise portfolio details.`}
                      inputProps={{ maxLength: 150 }}
                      InputProps={{ readOnly: true }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "1115px",
                        "& .MuiInputBase-root": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                  </Box>
                )}
              </Box>
            ) : null}

            {/* <FormHelperText sx={{fontSize:"12px"}}>Enter upto 1024 characters. Please share Asset wise portfolio details. */}

            {/* </FormHelperText> */}
            {selectedStatustype !== 24 && selectedStatustype !== 25 && (
              <Box>
                <Paper sx={styles.papercss}>Follow Up Details</Paper>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                >
                  <Box>
                    <Box
                      sx={{ fontSize: "15px", margin: "12px 0px -10px 0px" }}
                    >
                      Follow Up Mode
                    </Box>
                    <FormControl
                      sx={{ width: "300px", pr: 1, mt: 3 }}
                      size="medium"
                    >
                      <Select
                        value={selectedfollowuptype}
                        onChange={handlefollowupChange}
                        inputProps={{ readOnly: true }}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d3d3d3",
                          },
                        }}
                      >
                        {followuptypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{ fontSize: "12px", marginLeft: "-0.5px" }}
                      >
                        Please select what would be the mode of the followup.{" "}
                      </FormHelperText>
                    </FormControl>
                  </Box>
                  <Box sx={{ width: "300px" }}>
                    <Box
                      sx={{ fontSize: "15px", margin: "15px 0px -10px 0px" }}
                    >
                      Follow Up Date & Time
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        sx={{ marginTop: "12px" }}
                        components={["DateTimePicker"]}
                      >
                        <DateTimePicker
                          inputProps={{ readOnly: true }}
                          sx={{
                            backgroundColor: "#f5f5f5",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#d3d3d3",
                            },
                          }}
                          value={meetingDateTime}
                          onChange={handleDateTimeChange}
                          format="DD/MM/YYYY hh:mm A" // Customize the format here
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Box>
                  <Box>
                    <Box
                      sx={{ fontSize: "15px", margin: "12px 0px -10px 0px" }}
                    >
                      Follow Up Location Type
                    </Box>
                    <FormControl
                      sx={{ width: "300px", pr: 1, mt: 3 }}
                      size="medium"
                    >
                      <Select
                        value={selectedfollowuplocationtype}
                        onChange={handlefollowuplocationChange}
                        inputProps={{ readOnly: true }}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d3d3d3",
                          },
                        }}
                      >
                        {followuplocationtypes.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        sx={{ fontSize: "12px", marginLeft: "-1px" }}
                      >
                        Please select where the followup meeting will be held.{" "}
                      </FormHelperText>
                    </FormControl>
                  </Box>
                </Stack>
                {selectedfollowuptype === 36 && (
                  <Box>
                    <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
                      Location
                    </Box>
                    <TextField
                      multiline
                      variant="outlined"
                      value={followupdesc}
                      rows={3}
                      onChange={handlefollowChange}
                      helperText={`${followupcharcount}/150 characters. Enter up to 150 characters. Please add the exact address of the meeting, if done face-to-face.`}
                      inputProps={{ maxLength: 150 }}
                      InputProps={{ readOnly: true }}
                      fullWidth
                      sx={{
                        mt: 2,
                        width: "1115px",
                        "& .MuiInputBase-root": {
                          backgroundColor: "#f5f5f5",
                        },
                        "& .MuiFormHelperText-root": {
                          textAlign: "left",
                          marginLeft: "-1px",
                        },
                      }}
                    />
                  </Box>
                )}
              </Box>
            )}

            <Paper sx={styles.papercss}>Additional Information</Paper>
            <Box>
              <Box sx={{ fontSize: "15px", margin: "8px 0px -10px 0px" }}>
                Additional Comments
              </Box>
              <TextField
                multiline
                // label="Type here.."
                variant="outlined"
                value={additionalcomment}
                rows={3}
                onChange={handleadditionalcommentChange}
                helperText={`${additionalcomment?.length}/150 characters.Enter upto 150 characters. Enter additional information if needed.`}
                inputProps={{ maxLength: 150 }}
                InputProps={{ readOnly: true }}
                fullWidth
                sx={{
                  mt: 2,
                  width: "1115px",
                  "& .MuiInputBase-root": {
                    backgroundColor: "#f5f5f5",
                  },
                  "& .MuiFormHelperText-root": {
                    textAlign: "left",
                    marginLeft: "-1px",
                  },
                }}
              />
              {/* <FormHelperText sx={{fontSize:"12px"}}>Enter upto 255 characters. Please add the exact address of the meeting, if done face-to-face. </FormHelperText> */}
            </Box>

            {/* <Box
              sx={{
                display: "flex ",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Button
                onClick={cancelHandler}
                variant="outlined"
                sx={{
                  color: "Black",
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  padding: "5px 15px",
                  background: "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  textTransform: "none",
                  backgroundColor: !discussionBrief ? "#ccc" : "#002C51", // Different background color when disabled
                  "&:hover": {
                    backgroundColor: !discussionBrief ? "#ccc" : "#003D6B", // Adjust hover color when disabled
                  },
                }}
                disabled={!discussionBrief}
              >
                Save
              </Button>
            </Box> */}
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default Interactionmodal;

const styles = {
  textfield: {
    width: "335px",
  },
  papercss: {
    heignt: "250px",
    width: "102%",
    color: "white",
    fontSize: "17px",
    fontWeight: "bold",
    // border:"1px solid red",
    padding: "12px",
    marginBottom: "12px",
    marginTop: "14px",
    backgroundColor: "#223d6c",
  },
  flex: {
    display: "flex",
  },
};
